import { css } from '@/styled-system/css';

export const progressStepperStepMetaTextStyles = css.raw({
  textStyle: 'body-sm',
});
